import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

export function initAuth(auth: AuthService) {
  return () => {
    const token = auth.getToken?.();
    if (!token) return Promise.resolve(true);

    return firstValueFrom(
      auth.getCurrentUser().pipe(
        catchError(() => of(null))
      )
    );
  };
}
